import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../baseurl";
import { useNavigate } from "react-router-dom";
import Header from "../component/Header";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 
import logo from "../assets/img/logo1.webp";

function VendorLogin() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${baseurl}vendorLogin`, formData);

      Swal.fire({
        icon: "success",
        title: res.data.message || "Login successful!",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
        background: "#28a745",
        color: "#fff",
      });

      localStorage.setItem("vendorToken", res.data.token);
      localStorage.setItem("vendorId", res.data.user.id);
      localStorage.setItem("vendorRole", res.data.user.role);

      navigate("/dashboard");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: err.response?.data?.error || "Invalid credentials",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
        background: "#e74c3c",
        color: "#fff",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Header /> */}

      <div className="vendor-login-wrapper">
        <div className="vendor-login-container">
          {/* LEFT SECTION */}
          <div className="vendor-left">
            <img src={logo} className="img-fluid" style={{maxHeight: "80px"}} />
            <h1 className="title">SubCity Vendor Portal</h1>
            <p className="subtitle">
              Manage products, track sales, and grow your business.
            </p>

            <div className="benefit-box">
              <p>🚀 Reach thousands of customers</p>
              <p>📦 Manage inventory in real-time</p>
              <p>💳 Fast & secure payouts</p>
              <p>📊 Powerful analytics dashboard</p>
            </div>

            <p className="highlight-text">
              Start selling today & boost your revenue!
            </p>
          </div>

          {/* RIGHT SECTION (LOGIN CARD) */}
          <div className="vendor-right text-start">
            <div className="login-card">
              <h3>Vendor Login</h3>
              <p className="login-subtitle">
                Sign in to access your seller dashboard
              </p>

              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label className=" text-start">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="you@business.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className=" text-start">Password</label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="toggle-icon"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <button className="btn-login" type="submit" disabled={loading}>
                  {loading ? "Logging in..." : "Login"}
                </button>

                <p className="forgot-link">
                  <a href="/vendor/forgot-password">Forgot Password?</a>
                </p>
              </form>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default VendorLogin;
